import React from 'react';
import PropTypes from 'prop-types';

import AuthContainer from '../../auth/AuthContainer';
import ResetPasswordForm from '../../auth/reset-password/ResetPasswordForm.jsx';

const ResetPassword = props => {
  const { token } = props.match.params;
  return (
    <AuthContainer>
      <p className="auth-page-title">Create new password</p>
      <ResetPasswordForm token={token} />
    </AuthContainer>
  );
};

ResetPassword.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ResetPassword;
